import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "_rounded--common _flexcol _pos-r _gap-h _ov-h" }
const _hoisted_2 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.items, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.iconName,
        class: "_pa-3 _bgc--light _flex _gap-2 _ai-c"
      }, [
        _createElementVNode("div", null, [
          _createVNode(_component_base_icon, {
            name: item.iconName,
            size: "2x",
            class: "_tc--accent",
            "is-fixed-width": "",
            "icon-namespace": item.iconNamespace,
            "has-base-class": ""
          }, null, 8 /* PROPS */, ["name", "icon-namespace"])
        ]),
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(item.text) + " ", 1 /* TEXT */),
          (item.moreUrl)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: item.moreUrl,
                class: "_tc--accent"
              }, _toDisplayString(item.moreLabel), 9 /* TEXT, PROPS */, _hoisted_2))
            : _createCommentVNode("v-if", true)
        ])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}